import { useState } from 'react'
import { useFields } from '@hooks'
import { getInputPropsForModalForms } from '@utils/getInputPropsForModalForms'
import { Vendor, VendorKey, vendorSchema } from '@api/models'
import { FormSubmitEvent } from '@types'
import { validateAndSubmit } from '@utils/validateAndSubmit'
import { ReactSelectOptions, SelectType } from '@components/common/Select/Select.types'
import { StagedAttachment, VendorFormSubmissionData } from '@api/attachments/models/Attachment.model'

export interface VendorFormProps {
  isEdit?: boolean
  initialValues: Vendor
  handleSubmit: (payload: VendorFormSubmissionData) => Promise<void>
  canEdit?: boolean
}

interface UseVendorFormParams {
  initialValues: Vendor
  handleSubmit: (payload: VendorFormSubmissionData) => Promise<void>
  canEdit: boolean
  stagedAttachments: StagedAttachment[]
}

export const useVendorForm = ({ initialValues, handleSubmit, canEdit, stagedAttachments }: UseVendorFormParams) => {
  const { fields } = useFields()
  const [form, setForm] = useState({
    values: initialValues,
    errors: {},
  })

  function getField(
    name: VendorKey,
    select?: SelectType,
    selectOptions?: ReactSelectOptions
  ) {
    const field = getInputPropsForModalForms({
      name,
      select,
      selectOptions,
      fieldMap: fields,
      schema: vendorSchema as any,
      initialValues,
      form,
      setForm,
    })

    return { ...field, readOnly: !canEdit }
  }

  async function handleFormSubmit(e: FormSubmitEvent): Promise<void> {
    e.preventDefault()
    
    const wrappedHandleSubmit = (vendorData: Vendor) => {
      const submissionData: VendorFormSubmissionData = {
        vendorData,
        stagedAttachments,
      }
      return handleSubmit(submissionData)
    }
    
    await validateAndSubmit(vendorSchema as any, form, setForm, wrappedHandleSubmit)
  }

  const currentVendorID = form.values.VN_VEN_ID

  return {
    getField,
    handleFormSubmit,
    currentVendorID,
  }
}
